import { createContext, ReactNode } from 'react';

export interface CategoryTreeControllerValue {
  onAddChild?: (parentID: number) => void;
  onDelete?: () => void;
}

export const CategoryTreeControllerContext = createContext(
  {} as CategoryTreeControllerValue,
);

interface CategoryTreeControllerProps extends CategoryTreeControllerValue {
  children?: ReactNode;
}

export const CategoryTreeController = (props: CategoryTreeControllerProps) => (
  <CategoryTreeControllerContext.Provider
    value={{ onAddChild: props.onAddChild, onDelete: props.onDelete }}
  >
    {props.children}
  </CategoryTreeControllerContext.Provider>
);
